import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Steps } from "antd";

const ProgressBarTransactionMode6 = (props) => {
  const { t } = useTranslation();
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    if (props.transaction) {
      if (
        props.transaction.agreement_accepted_by_counterparty === true &&
        props.transaction.agreement_accepted_by_initiator === true
      ) {
        setCurrentStage(1);

        if (props.transaction.escrow_received) {
          setCurrentStage(2);

          if (props.transaction.items_sent) {
            setCurrentStage(3);

            if (props.transaction.finished) {
              setCurrentStage(4);
              setCurrentStage(5);
            }

          }
        }
      }
    }
  }, [props.transaction]);

  const steps = [
    {
      title: t('transaction.agreement.title'),
      description: t('transaction.progress.agreementNegotiationDesc'),
    },
    {
      title: t('welcome.giftCard') + " w Escrow",
      description: t('transaction.progress.escrowTransferDesc'),
    },
    {
      title: t('transaction.progress.taskExecution'),
      description: t('transaction.progress.taskExecutionDesc'),
    },
    {
      title: t('transaction.progress.taskReceival'),
      description: t('transaction.progress.taskReceiptFailure'),
      status: "error"
    },
    {
      title: t('transaction.progress.contractCompletion'),
      description: "Zwrot karty podarunkowej",
    },
  ];

  if (
    props.transaction !== null &&
    props.transaction.transaction_mode_id !== 6
  ) {
    return <></>;
  }

  if (props.transaction !== null) {
    return <Steps size="small" current={currentStage} items={steps} />;
  }
};

export default ProgressBarTransactionMode6;
